import React from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Jumbotron from 'react-bootstrap/Jumbotron';
import styled from 'astroturf';
import withProps from 'recompose/withProps';
import pkg from '../../../package.json';

import withLayout from '../withLayout';

const MastHead = styled(Jumbotron, null, "MastHead", require("./index-MastHead.module.scss"), "mast-head", "mastHead");

const Content = styled('div', null, "Content", require("./index-Content.module.scss"), "content", "content");

const Heading = styled('h1', null, "Heading", require("./index-Heading.module.scss"), "heading", "heading");

const SubHeading = styled('p', null, "SubHeading", require("./index-SubHeading.module.scss"), "sub-heading", "subHeading");

const BrandButton = styled(Button, null, "BrandButton", require("./index-BrandButton.module.scss"), "brand-button", "brandButton");

const FeatureCard = withProps({ md: 4 })(
  styled(Col, null, "FeatureCard", require("./index-FeatureCard.module.scss"), "feature-card", "featureCard"),
);

const ButtonToolbar = styled('div', null, "ButtonToolbar", require("./index-ButtonToolbar.module.scss"), "button-toolbar", "buttonToolbar");

export default withLayout(
  class HomePage extends React.Component {
    render() {
      return (
        <main id="rb-docs-content">
          <MastHead fluid>
            <Content>
              <Heading>React Bootstrap</Heading>
              <SubHeading>
                The most popular front-end framework
                <br />
                <strong>Rebuilt</strong> for React.
              </SubHeading>
              <ButtonToolbar>
                <BrandButton
                  size="lg"
                  variant="brand"
                  className="mr-3 px-5"
                  href="/getting-started/introduction"
                >
                  Get started
                </BrandButton>
                <Button
                  size="lg"
                  href="/components/alerts"
                  className="px-5"
                  variant="outline-light"
                >
                  Components
                </Button>
              </ButtonToolbar>
              <div className="text-muted mt-3">
                Current version: {pkg.version}
              </div>
            </Content>
          </MastHead>

          <Container>
            <Row>
              <FeatureCard>
                <h2>Rebuilt with React</h2>
                <p>
                  React bootstrap replaces the Bootstrap javascript. Each
                  component has been built from scratch as true React
                  components, without uneeded dependencies like jQuery.
                </p>
                <p>
                  As one of the oldest React libraries, react bootstrap has
                  evolved and grown along-side React, making it an exellent
                  choice as your UI foundation.
                </p>
              </FeatureCard>

              <FeatureCard>
                <h2>Bootstrap at its core</h2>
                <p>
                  Built with compatibility in mind, we embrace our bootstrap
                  core and strive to be compatible with the world's largest UI
                  ecosystem.
                </p>
                <p>
                  By relying entirely on the Bootstrap stylesheet, React
                  bootstrap, just works with the thousands of bootstrap themes
                  you already love.
                </p>
                <p />
              </FeatureCard>

              <FeatureCard>
                <h2>Accessible by default</h2>

                <p>
                  The React component model gives us more control over form and
                  function of each component.
                </p>
                <p>
                  Each component is implemented with accessibility in mind. The
                  result is a set of accessible-by-default components, over what
                  is possible from plain Bootstrap.
                </p>
              </FeatureCard>
            </Row>
          </Container>
        </main>
      );
    }
  },
);
